import React, { useState } from 'react'
import Header from 'components/Header'
import Sidebar from 'components/Sidebar'
import { APP_ROUTES } from 'routes';
import PropTypes from 'prop-types';

export default function DashboardWrapper(props) {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    return (

        <div className="flex h-screen w-full overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} data={APP_ROUTES} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className=''>
                    <div className="px-4  py-4 w-full max-w-9xl mx-auto">
                        {props.children}
                    </div>
                </main>
            </div >
        </div>
    )
}

DashboardWrapper.propTypes = {
  children: PropTypes.node,
};
